import React from "react";
import moment from "moment";
import styles from "./tooltip-component.scss";
import { decorateValue } from "../../../../styles/cell-decorators";
import BaseTooltipComponent from "./base-tooltip-component";
import LegendItemWrapper from "../../../../visx_components/legend/legendItem";

const ComboTooltipComponent = (props) => (datumProps) => {
  const datum = datumProps?.nearestDatum?.datum;
  const {
    section,
    entities,
    valueDecorator,
    xKey,
    keyFormatter = (x) => x,
  } = props;
  return (
    datum && (
      <BaseTooltipComponent additionalStyles={styles.boxshadowStyle}>
        <table>
          <tbody>
            <tr className={styles.tooltipRow}>
              <td>{moment(datum[xKey]).format("MM/DD/YYYY")}</td>
              <td>{section}</td>
            </tr>
            {Object.keys(datum).map(
              (x, i) =>
                entities[x] && (
                  <tr key={i} className={styles.tooltipRow}>
                    <td className={styles.tooltipLegendWrapper}>
                      <LegendItemWrapper
                        label={{
                          value: entities[x].stroke,
                        }}
                        strokeDasharray={entities[x].strokeDasharray}
                        width={entities[x].width}
                      />
                      {keyFormatter(x)}
                    </td>
                    <td>{decorateValue(datum[x], entities[x].decorator)}</td>
                  </tr>
                )
            )}
          </tbody>
        </table>
      </BaseTooltipComponent>
    )
  );
};

export default ComboTooltipComponent;
